import { RowsPlusBottomIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const InsertNext = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <RowsPlusBottomIcon {...rest} size={Sizes[size]} height={Sizes[size]} color={fill} />;
};

InsertNext.displayName = 'InsertNext';
